module.exports = __webpack_public_path__ + "img/紫苏子.cbe79785.jpg";